import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectCreatedFolderId,
  selectFolderCreationError,
  selectLoadTemplatesError,
  selectTemplates,
} from './template.selectors';

@Injectable({ providedIn: 'root' })
export class TemplateSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly templates = this._store.selectSignal(selectTemplates);

  public readonly loadTemplatesError = this._store.selectSignal(
    selectLoadTemplatesError,
  );

  public readonly folderCreationError = this._store.selectSignal(
    selectFolderCreationError,
  );

  public readonly createdFolderId = this._store.selectSignal(
    selectCreatedFolderId,
  );
}
